import { render, staticRenderFns } from "./GlobalCaution.vue?vue&type=template&id=8c566198&"
import script from "./GlobalCaution.vue?vue&type=script&lang=js&"
export * from "./GlobalCaution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports